import getRepoFilters from 'api/v2/repository/getRepoFilters';
import { adaptFilters } from 'components/pages/DocumentsRepository/filtersConfig';
import { debounce } from 'lodash';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import filtersStoreCreatorV2 from 'store/shared/filters/filtersStoreCreatorV2';
import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import { getTracingEvents } from 'utils/amplitude';
import { WEBAPP_BANKSLIST_CHANGEDFILTERS } from 'utils/amplitude/events/bank.amplitude';
import { mergeFilters } from 'utils/helpers';
import useGetRepositoryTags from './useGetRepositoryTags';

export const useRepoFiltersStore = filtersStoreCreatorV2();

const tracingEvents = getTracingEvents({
  onChange: WEBAPP_BANKSLIST_CHANGEDFILTERS,
});

const logFilterChanges = debounce(tracingEvents.onChange, 500);

const useDocumentsRepositoryFilters = () => {
  const filtersConfig = useRepoFiltersStore();

  useEffect(() => {
    return useRepoFiltersStore.subscribe((state, prev) => {
      if (state.filtersData === prev.filtersData) return;
      logFilterChanges();
    });
  }, []);

  const cacheKey = DocumentsRepositoryCacheKeys.DocumentsRepositoryFilters;

  const tagsQuery = useGetRepositoryTags();

  const filtersQuery = useQuery(
    [cacheKey, tagsQuery.data],
    () =>
      getRepoFilters().then((filters) => {
        const newFilters = mergeFilters(
          filtersConfig.getFilters(),
          adaptFilters(filters, tagsQuery.data || []),
        );
        filtersConfig.setFilters(newFilters);
        return newFilters;
      }),
    {
      staleTime: 0,
      enabled: !!tagsQuery.data?.length,
    },
  );

  return {
    filtersConfig,
    filtersQuery,
  };
};

export default useDocumentsRepositoryFilters;
